//
// Module for the Review Individual Correspondence view
//
rs.module("framework/content/correspondence/review/reviewindividualcorrespondence",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, distributionMethods, userDefaults) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var distributionMethodSelect = criteria.js(jsSelectors.distributionMethodSelect);
            var emailContainer = criteria.js(jsSelectors.emailContainer);
            var emailAddress = criteria.js(jsSelectors.emailAddress);
            var ccEmailAddress = criteria.js(jsSelectors.ccEmailAddress);
            var emailSubject = criteria.js(jsSelectors.emailSubject);
            var emailBody = criteria.js(jsSelectors.emailBody);

            var printContainer = criteria.js(jsSelectors.printContainer);
            var printerSelect = criteria.js(jsSelectors.printerSelect);

            // Get select helper(s) for working with select lists
            var printerSelectHelper = selectHelper.getHelper(printerSelect);

            // Handle the send method change event
            distributionMethodSelect.change(function () {

                var selectedDistributionMethod = $(this).val();

                // Clear fields and errors
                [
                    emailAddress,
                    ccEmailAddress,
                    emailSubject,
                    emailBody
                ].forEach((input) => input.clearErrors().val(''));

                // Identify selected distribution
                var isDefault = (selectedDistributionMethod & distributionMethods.defaultDistribution) == distributionMethods.defaultDistribution;
                var isPrint = (selectedDistributionMethod & distributionMethods.print) == distributionMethods.print;
                var isEmail = (selectedDistributionMethod & distributionMethods.email) == distributionMethods.email;

                if (isDefault) {
                    
                    if (isEmail) {

                        emailAddress.val(userDefaults.defaultEmail).prop('disabled', true);
                    }
                    else if (isPrint) {

                        printerSelectHelper.setValue(userDefaults.defaultPrinter);
                    }
                }
                else {

                    emailAddress.prop('disabled', false);
                }

                visibility.setVisible(emailContainer, isEmail);
                visibility.setVisible(printContainer, isPrint);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);